import { Grid } from "modules/common/components/Grid";
import { Box, Heading, SimpleGrid } from "@chakra-ui/react";
import type { TopThreeProps } from "./TopThree.d";

const TopThree = ({ heading, children }: TopThreeProps) => (
  <Box bg="greyscale.300" pt={{ base: 12, lg: 20 }}>
    <Grid mb={0}>
      <Box gridColumn={{ base: "span 1", md: "span 12" }}>
        <Heading variant="h2" as="h2" mb={10} textAlign={{ base: "left", lg: "center" }}>
          {heading}
        </Heading>
        <SimpleGrid columns={{ base: 1, lg: 3 }} spacing={8}>
          {children}
        </SimpleGrid>
      </Box>
    </Grid>
  </Box>
);

export default TopThree;
